import { render, staticRenderFns } from "./PdfMake.vue?vue&type=template&id=c1dd8a36&"
import script from "./PdfMake.vue?vue&type=script&lang=js&"
export * from "./PdfMake.vue?vue&type=script&lang=js&"
import style0 from "./PdfMake.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports